import React from 'react';
import { Box, Button, Container, Stack } from '@mui/material';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppHeader from './AppHeader';

export default function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isInsideProject = /^\/projects\/[^/]+/.test(location.pathname);
  const isInsideAdmin = /^\/admin(?:\/|$)/.test(location.pathname);
  const showHomeButton = isInsideProject || isInsideAdmin;

  return (
    <Stack
      className="app-shell-bg"
      sx={{
        minHeight: '100vh',
        position: 'relative',
        backgroundColor: 'background.default',
        alignItems: 'stretch',
      }}
    >
      <Box className="app-shell-layer">
        <Box className="app-orb app-orb--one" />
        <Box className="app-orb app-orb--two" />
        <Box className="app-orb app-orb--three" />
      </Box>
      <AppHeader />
      <Box
        component="main"
        className="page-enter"
        sx={{
          flexGrow: 1,
          width: '100%',
          position: 'relative',
          zIndex: 1,
          py: { xs: 2, md: 3 },
          px: { xs: 2, md: 4 },
          boxSizing: 'border-box',
        }}
      >
        <Container maxWidth="xl" sx={{ px: { xs: 0, md: 1 } }}>
          {showHomeButton && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1.5 }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<HomeRoundedIcon />}
                onClick={() => navigate('/')}
              >
                На главную
              </Button>
            </Box>
          )}
          <Outlet />
        </Container>
      </Box>
    </Stack>
  );
}
